import { useState } from "react";
import { Lock } from "lucide-react";
import { CC_COSTS, EMBER, fmt, fmt0, fmt2 } from "./config";

function Cell({ label, value, sub }) {
  return (
    <div>
      <p className="pcp-mono text-[10px] opacity-60">{label}</p>
      <p className="font-semibold">{value}</p>
      {sub && <p className="text-[10px] opacity-50">{sub}</p>}
    </div>
  );
}

/* Admin-only internal ComplyCube margin math — never surfaced to clients. */
export function MarginPanel({ cc, companies, monthlyPlatform }) {
  const [showMargin, setShowMargin] = useState(false);
  return (
    <div className="mt-6 pcp-card p-5" style={{ borderColor: EMBER }} data-testid="internal-margin-panel">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Lock className="h-4 w-4" style={{ color: EMBER }} />
          <p className="pcp-mono text-[11px]" style={{ color: EMBER }}>Internal · admin only · ComplyCube cost math</p>
        </div>
        <button
          type="button"
          onClick={() => setShowMargin((v) => !v)}
          className="pcp-mono text-[11px] opacity-70 hover:opacity-100"
          data-testid="margin-toggle"
        >
          {showMargin ? "Hide" : "Show"} margin math
        </button>
      </div>
      {showMargin && (
        <div className="space-y-4">
          <div className="grid md:grid-cols-4 gap-3 text-sm">
            <Cell label="Onboarding (passive)" value={fmt2(CC_COSTS.onboarding_passive)} sub="ID + liveness + PEP" />
            <Cell label="Onboarding (active)" value={fmt2(CC_COSTS.onboarding_active)} sub="+ video liveness" />
            <Cell label="Vendor / KYB" value={fmt2(CC_COSTS.vendor_screen)} sub="business screening" />
            <Cell label="Monitoring" value={`${fmt2(CC_COSTS.monitoring_profile)}/mo`} sub="per profile" />
          </div>
          <div className="grid md:grid-cols-4 gap-3 text-sm pt-3 border-t border-black/10">
            <Cell label="Screening cost / mo" value={fmt(cc.totalScreeningCost)} sub={`× ${companies} companies`} />
            <Cell label="Blended labor" value={fmt(cc.laborBlended)} sub="~55% of team subtotal" />
            <Cell label="Gross" value={fmt(cc.gross)} sub="revenue − COGS − fixed" />
            <Cell label="Margin" value={`${cc.margin}%`} sub={`of ${fmt(monthlyPlatform || 0)}`} />
          </div>
          <p className="pcp-mono text-[10px] opacity-55">
            Shared ComplyCube committed monthly balance: {fmt0(CC_COSTS.shared_balance)} across the whole book (not per client). ComplyCube quoted rates expire Feb 15, 2026 — lock before then.
          </p>
        </div>
      )}
    </div>
  );
}
